var CartPage = {
  init: function () {
    if (!document.querySelector('.section-cart')) return;

    const root = window.Shopify?.routes?.root || '/';
    let noteTimeout;

    $(document).on('input', '#CartNote', function () {
      clearTimeout(noteTimeout);

      const note = $(this).val();

      noteTimeout = setTimeout(function () {
        $.post(root + 'cart/update.js', { note: note }, null, 'json');
      }, 500);
    });
  }
};

$(function () {
  CartPage.init();
});
